var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.link)?_c('a',{staticClass:"float doc-link",attrs:{"href":"#","href":_vm.url,"target":"_blank"}},[_vm._v("\n\t\tEdit on Github\n\t")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }